










































































  import Vue from "vue";
  import {DonationCase} from "@/interfaces/donation/donationcase/donationCase";
  import {Donor} from "@/interfaces/donation/donor";

  export default Vue.extend({
    props: {
      donor: {
        type: Object as () => Donor,
        required: true
      }
    },
    data() {
      return {};
    },
    computed: {
      donorName() {
        if(this.donor && this.donor.firstname.length > 0)
        {
          return this.donor.firstname + ' ' + this.donor.surname
        }
        return this.$t("donorDetails.anonymous")
      }
    }
  });
